<template lang="pug">
#setAddBank.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='setAddBank-tab')
  form.mt-5
    .mb-3
      label.col-form-label {{ $t('ui.bank_name') }}
      .select-image
        .select-image-input(@click="toggleList" v-if="bankId===''")
          | {{ $t('ui.please_select_bank') }}
        .select-image-input(@click="toggleList" v-else)
          .select-image-option
            //- img(:src="'images/depo/bank/' + bankId + '.png'" alt :value="bankId")
            img(:src="'assets/img/bank2/bank-' + bankId + '.jpg'" alt :value="bankId")
            |  {{ bankName }}
        .select-image-list.mb-2(:class="{'show': showList}")
          .select-image-option(v-for="(bank, i) in bankList"  @click="setBank($event, i)")
            //- img(:src="'images/depo/bank/' + bank.bank_id + '.png'" alt :value="bank.bank_id")
            img(:src="'assets/img/bank2/bank-' + bank.bank_id + '.jpg'" alt :value="bank.bank_id")
            |  {{ bank.bank_name }}
      input.form-control.lower.d-none(type="text" ref="bankId" v-model.trim="$v.bankId.$model")
      .error.w-100(v-if="$v.bankId.$model == '' && $v.bankId.$dirty")
        small.text-danger.form-text {{ $t('ui.please_select_bank') }}
    .mb-3
      label.col-form-label {{ $t('ui.bank_accname') }}
      input.form-control(type='text' ref="bankAccName" v-model.trim="$v.bankAccName.$model")
      .error.w-100(v-if="!$v.bankAccName.required && $v.bankAccName.$dirty")
        small.text-danger.form-text {{ $t('ui.enter_bank_accname') }}
    .mb-3
      label.col-form-label {{ $t('ui.bank_accno') }}
      input.form-control(v-model.trim="$v.bankAccNumber.$model" @keypress="$helpers.onlyNumber" @paste.prevent)
      .error.w-100(v-if="!$v.bankAccNumber.required && $v.bankAccNumber.$dirty")
        small.text-danger.form-text {{ $t('ui.enter_bank_accno') }}
    label.col-form-label {{ $t('ui.tac_code') }}
    .input-group.mb-3
      input.form-control(type="text" autocomplete="off" ref="tacCodeBank" v-model.trim="$v.tacCodeBank.$model" @keypress="$helpers.onlyNumber")
      .input-group-append
        button.resend.btn.btn-outline-secondary(type='button' @click.prevent="memberBankTac") {{ $t("ui.request_again") }}
      ValidateResult(:value="$v.tacCodeBank" :name="$t('ui.tac_code')")
    .mt-4.text-center.d-flex.gap-4.justify-content-center
      button.btn-submit(type='submit' @click.prevent="memberAddBank") {{ $t('ui.save') }}
</template>
<script>
import config from '@/config'
import errorTags from '@/errorTags'
import { required, not } from 'vuelidate/lib/validators'
import ValidateResult from "@/library/ValidateResult"

export default {
  components: {
    ValidateResult
  },
  data(){
    return{
      bankAccName: "",
      bankAccNumber: null,
      bankName:"",
      bankId:"",
      bankList: [],
      tacCodeBank: "",
      feedback:{
        success: true,
        status:""
      },
      showList: false
    }
  },
  validations() {
    return {
      bankAccName:{
        required
      },
      bankAccNumber:{
        required
      },
      bankId:{
        required
      },
      tacCodeBank:{
        required
      }
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  mounted() {
    let vm = this
    if (vm.$store.getters.isLoggedIn) {
      vm.getBankList()
    }

    $('#bank-dropdown-list').on("click", function() {
      $(".bank-dropdown-wrap").toggle()
    })

    $(".btn-select").on("click",function() {
      $(".bank-dropdown-wrap").toggle()
    })
  },
  methods:{
    toggleList(){
      this.showList = !this.showList
    },
    reset(){
      this.bankAccName = ""
      this.bankAccNumber = ""
      this.bankId = ""
      this.tacCodeBank = ""
      this.$v.$reset()
    },
    setBank(e, i) {
      if(this.bankList) {
        this.bankId = this.bankList[i].bank_id
        this.bankName = this.bankList[i].bank_name
        this.toggleList()
      }
    },
    memberBankTac() {
      let account_id = this.accountID
      let auth_token = this.sessionToken
      this.$store
        .dispatch("user/memberBankTac", { account_id, auth_token })
        .then(response => {
          if (response.success == true) {
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
            }
          }
        })
        .catch(response => {
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
          }
        })
    },
    getBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/bankLookUp", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              if(response.data) {
                if(response.data.length > 0) {
                  this.bankList = response.data
                  // this.bankId = this.bankList[0].bank_id
                  // this.bankName = this.bankList[0].bank_name
                }
              }
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this)
            }
          })
      }
    },
    memberAddBank(){
      this.$v.$touch();
      if(!this.$v.$invalid){
        if(this.sessionToken) {
          let account_id = this.accountID
          let bank_id = this.bankId
          let bank_name = this.bankName
          let bank_acc_holder = this.bankAccName
          let bank_acc_no = this.bankAccNumber
          let tac_code = this.tacCodeBank
          let auth_token = this.sessionToken
          this.loading = true
          this.$store
            .dispatch("user/memberAddBank", { account_id, bank_id, bank_name, bank_acc_holder, bank_acc_no, tac_code, auth_token })
            .then(response => {
              this.loading = false
              this.feedback.success = response.success
              this.feedback.status = response.status
              if (this.feedback.success == true) {
                this.reset()
                this.$helpers.showDialog(this.$t("ui.success").toUpperCase(), this.$t("message.add_bank_success"), "success", this)
                this.getMemberBankList()
              } else {
                this.feedback.status = this.$t("error." + response.status)
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                }
              }
            })
            .catch(response => {
              this.loading = false
              this.feedback.success = false
              this.feedback.status = this.$t("error." + response.status)
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            })
        }
      }
    },
    getMemberBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberBankList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.$emit("switchTab", 1)
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.resbox-tabs .tab-content .tab-pane {
  overflow: visible;
}
.select-image .select-image-list{
  z-index: 3;
  overflow: auto;
  max-height: 400px;
}
</style>